import { SpeedInsights } from '@vercel/speed-insights/react'
import Layout from 'layout'
import { any } from 'prop-types'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import InternalServerError from './InternalServerError'
import Loading from './Loading'
const Account = ({ children = 'No content' }) => {
	const status = useSelector(state => state?.user?.STATUS)
	return status === 'LOADING' ? (
		<Loading />
	) : status === 'SERVER_ERROR' ? (
		<InternalServerError />
	) : status === 'SUCCESS' ? (
		<Layout>
			{children}
			<SpeedInsights />
		</Layout>
	) : (
		<Navigate to='/auth?tab=0' />
	)
}
Account.propTypes = {
	children: any,
}
export default Account
